import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '../../custom-material/Services/';
import { BuildingModel, BuildingTypeModel } from '../../main/Models/';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'building-datasheet',
  templateUrl: './t_datasheet.component.html',
  styleUrls: ['./datasheet.component.less']
})
export class DatasheetComponent implements OnInit {

  @Input() building: BuildingModel;
  @Output() saveTriggered:EventEmitter<BuildingModel> = new EventEmitter();


  content: string = "Chargement ...";
  prepared: boolean = false;

  constructor(
    private apiService: ApiService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
  	if(this.building.datasheet!=undefined) {
  		this.content = this.building.datasheet; 
      this.prepareIframe();
  	} else {
  		this.loadDatasheet();
  	}
  }

  loadDatasheet()
  {
    setTimeout(()=>{ this.snackBar.open('Chargement en cours') }, 0);
  	let loadUrl = 'datasheet/'+this.building.id;
  	this.apiService.getTextFromServer('datasheet', this.building.id)
      .then(s => s.subscribe((response:any) => {
      	this.content = response;
        this.prepareIframe();
        setTimeout(()=>{ this.snackBar.dismiss(); }, 400);
      }));
  }

  reset()
  {
    this.building.datasheet = undefined;
    this.loadDatasheet();
  }

  prepareIframe()
  {
    if(!this.prepared) {
      this.prepared = true;
      setTimeout(()=>{this.prepared = false}, 200);
      setTimeout(()=>{this.prepared = true}, 500);
      setTimeout(() => {
        let height = window.document.getElementsByTagName('iframe')[0].clientHeight;
        height  *= 1.1;
        window.document.getElementsByTagName('iframe')[0].style.height = height+'px';
      }, 2000);
    }
  }

  save()
  {
    this.building.datasheet = this.content;
    this.apiService.UpdateToServer('building', this.building.export())
        .then(s => s.subscribe((response:any) => {
          this.saveTriggered.emit(response);
      }));
  }

}
